/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 70d2f0aa (Mon Feb 23 19:51:14 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import { CashAmount, CashAmountFromJSON, CashAmountToJSON } from './'

/**
 *
 * @export
 * @interface TutorLicensingFeePerRateBreakdown
 */
export interface TutorLicensingFeePerRateBreakdown {
  /**
   *
   * @type string
   * @memberof TutorLicensingFeePerRateBreakdown
   */
  fee?: TutorLicensingFeePerRateBreakdownFeeEnum
  /**
   *
   * @type number
   * @memberof TutorLicensingFeePerRateBreakdown
   */
  count: number
  /**
   *
   * @type {Array<number>}
   * @memberof TutorLicensingFeePerRateBreakdown
   */
  appliesToStudents?: Array<number>
  /**
   *
   * @type CashAmount
   * @memberof TutorLicensingFeePerRateBreakdown
   */
  amount: CashAmount
}

/**
 * @export
 * @enum {string}
 */
export enum TutorLicensingFeePerRateBreakdownFeeEnum {
  FirstSpotInvitation = 'firstSpotInvitation',
  AdditionalSpotsInvitation = 'additionalSpotsInvitation',
  Sem1FirstStudent = 'sem1FirstStudent',
  Sem1AdditionalStudent = 'sem1AdditionalStudent',
  Sem2FirstStudent = 'sem2FirstStudent',
  Sem2AdditionalStudent = 'sem2AdditionalStudent',
}

export function TutorLicensingFeePerRateBreakdownFromJSON(
  json: any
): TutorLicensingFeePerRateBreakdown {
  return TutorLicensingFeePerRateBreakdownFromJSONTyped(json, false)
}

export function TutorLicensingFeePerRateBreakdownFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TutorLicensingFeePerRateBreakdown {
  if (json === undefined || json === null) {
    return json
  }
  return {
    fee: !exists(json, 'fee') ? undefined : json['fee'],
    count: json['count'],
    appliesToStudents: !exists(json, 'appliesToStudents')
      ? undefined
      : json['appliesToStudents'],
    amount: CashAmountFromJSON(json['amount']),
  }
}

export function TutorLicensingFeePerRateBreakdownToJSON(
  value?: TutorLicensingFeePerRateBreakdown | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    fee: value.fee,
    count: value.count,
    appliesToStudents: value.appliesToStudents,
    amount: CashAmountToJSON(value.amount),
  }
}
